import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'
import Datepicker from 'flowbite-datepicker/Datepicker'
import no from '../../../../node_modules/flowbite-datepicker/js/i18n/locales/no.js'
import { format } from 'date-fns'

export default class extends Controller {
  static targets = ['picker', 'date']
  static values = { param: String, options: Object, date: String }

  handleDateInputEvent() {
    this.datepicker.update()
  }

  handleDateClick(event) {
    // If user has clicked on a date
    if (event.target.dataset.date) this.onDateClick()
  }

  // To be overwritten by other controllers with an outlet
  onDateClick() {
    // Behavior unless overwritten

    if (!this.paramValue) return

    if (!this.optionsValue.autoHide) {
      const currentUrl = new URL(window.location.href)
      currentUrl.searchParams.set(
        this.paramValue,
        format(this.selectedDate, 'yyyy-MM-dd')
      )
      Turbo.visit(currentUrl.href)
    } else {
      this.datepicker.setDate(this.selectedDate)
      this.dateTarget.value = format(this.selectedDate, 'EEEE dd. MMMM yyyy')
      this.datepicker.hide()
    }
  }

  initialize() {
    Datepicker.locales.no = no.no
    this.datepicker = new Datepicker(this.pickerTarget, this.optionsValue)
  }

  connect() {
    this.element.addEventListener(
      'dateinput',
      this.handleDateInputEvent.bind(this)
    )
  }

  get selectedDate() {
    return this.datepicker.getDate()
  }
}
